import R14 from "../core";

export default class ACHPaymentDomain extends R14.Domain {

    // create-setup-intent
    async createSetupIntent(payload) {
        try {
            let res = await this.dm.queryDomain.middleware(this.api.mutate(
                `mutation CreateSetupIntent($input: CreateSetupIntentInput!) {
                createSetupIntent(input: $input){       
                    success
                    message
                    payerBankAccount {
                        uid intentId routingNumber accountNumber pId billerPid metaData isBankVerified isActive createdAt bankName billerName
                    }
                }            
            }`,
                {
                    input: payload,
                }
            ));
            return res.data;
        } catch (error) {
            return error;
        }
    }

    async getPayerBankAccounts(filter) {
        try {
            let res = await this.api.qry(`
             query PayerBankAccount($filter: PayerBankAccountFilter, $page: Int, $resultsPerPage: Int, $sort: [SortOption!]) {
                    payerBankAccounts(filter: $filter, page: $page, resultsPerPage: $resultsPerPage, sort: $sort){
                    totalCount @include(if: true)
                    nodes {
                        uid intentId routingNumber accountNumber pId billerPid metaData isBankVerified isActive createdAt bankName billerName verificationStatus message buId buName
                    }
                    }
                }`,
                {
                    filter: filter,
                    sort: [
                        {
                            field: "pid",
                            order: "ASC",
                        },
                    ],
                }
            );
            return res.data.payerBankAccounts.nodes;
        } catch (error) {
            return error;
        }
    }

    // payment-intent
    async paymentIntent(payload) {
        try {
            let res = await this.dm.queryDomain.middleware(this.api.mutate(
                `mutation PaymentIntent($input: PaymentIntent!) {
                paymentIntent(input: $input)
            }`,
                {
                    input: payload,
                }
            ));
            return res.data;
        } catch (error) {
            return error;
        }
    }

    async updatePayerBankAccount(payload){
        try {
            let res = await this.api.mutate(
                `mutation PutPayerBankAccount($input: UpdatePayerBankAccountInput!) {
                putPayerBankAccount(input: $input) {
                    success
                }
            }`,
                {
                    input: payload,
                }
            );
            return res.data;
        } catch (error) {
            return error;
        }
    }
}